module.exports = __webpack_public_path__ + "img/manatee_sizing.5da791aa.png";